import React from "react";

const InProgressSign = ({ className }) => {
  return (
    <div className={className}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          style={{
            transformOrigin: "50% 50%",
            animation: "spin 1s linear infinite",
          }}
        >
          <path
            d="M8 2.5C5.24 2.5 3 4.74 3 7.5"
            stroke="#3B82F6"
            strokeWidth="1.4"
            strokeLinecap="round"
            fill="none"
          />
        </g>
      </svg>

      <style>
        {`
          @keyframes spin {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
        `}
      </style>
    </div>
  );
};

export default InProgressSign;
